<template>
  <div class="insurance-calculator">
    <div class="insurance-calculator__container">
      <SearchParams
        ref="searchParams"
        class="insurance-calculator__search-params"
        :contract-start-date="formatDate(contract.startDate)"
        :contract-estimated-period="contract.estimatedPeriod"
        :earnings="getCalculatorEarnings"
        :earnings-list="earningsList"
        :is-loading-earnings="isLoadingEarnings"
        @changeContractStartDate="onChangeContractStartDate"
        @changeContractEstimatedPeriod="onChangeContractEstimatedPeriod"
        @changeEarnings="onChangeEarnings"
      />
      <div class="insurance-calculator__controls">
        <div class="insurance-calculator__controls-wrapper">
          <p class="insurance-calculator__notice">
            Заповніть всі поля (<span class="insurance-calculator__notice--required">*</span>) щоб мати можливість скористатися пошуком
          </p>
          <BlueButton
            class="insurance-calculator__search"
            :is-loading="offers.isLoading"
            :is-disabled="!isFormValid"
            @click="onSearchOffers"
          >
            Показати результати
          </BlueButton>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import { mapActions, mapGetters } from 'vuex';
import { default as SearchParams } from './search-params';
import { petsPeriodLabels } from '@/entities/insurance/config';
import { FRANCHISE_DAYS } from '@/features/pets-calculator/config';
import { DateFormatter } from '@/shared/lib/calendar';
import { ContractState } from '@/shared/lib/insurance';
import { PetsCalculateParams } from '@/shared/lib/insurance/offer';
import { BlueButton } from '@/shared/ui/form';

const { formatDate } = DateFormatter();
const { preparePetsCalculationQueryParams } = PetsCalculateParams();

export default {
  data() {
    return {
      earningsList: [],
      isLoadingEarnings: false,
      offers: {
        isLoading: false,
      },
    };
  },
  mixins: [ContractState('petsModule')],
  components: { BlueButton, SearchParams },
  computed: {
    ...mapGetters('petsModule', ['getCalculatorEarnings']),
    isFormValid() {
      return !!(this.contract.startDate && this.contract.estimatedPeriod && this.getCalculatorEarnings);
    },
  },
  mounted() {
    const minDate = moment().add(FRANCHISE_DAYS, 'days').startOf('day');
    if (!this.contract.startDate || moment(this.contract.startDate, 'DD.MM.YYYY').isBefore(minDate)) {
      this.contract.startDate = minDate.format('DD.MM.YYYY');
    }
    if (!this.contract.estimatedPeriod || !(this.contract.estimatedPeriod in petsPeriodLabels)) {
      this.contract.estimatedPeriod = '6m';
    }
    this.fetchPetsTariffs();
  },
  methods: {
    ...mapActions('petsModule', [
      'calculatePets',
      'setCalculatorEarnings',
      'fetchTariffs',
    ]),
    formatDate,
    async fetchPetsTariffs() {
      this.isLoadingEarnings = true;
      try {
        this.earningsList = await this.fetchTariffs();
      } finally {
        this.isLoadingEarnings = false;
      }
    },
    onChangeContractStartDate(startDate) {
      this.contract.startDate = startDate;
    },
    onChangeContractEstimatedPeriod(estimatedPeriod) {
      this.contract.estimatedPeriod = estimatedPeriod;
    },
    onChangeEarnings(earnings) {
      this.setCalculatorEarnings(earnings);
    },
    async onSearchOffers() {
      if (!this.$refs.searchParams.validateAll()) {
        return;
      }

      this.offers.isLoading = true;

      const params = {
        startFrom: this.contract.startDate,
        insurancePeriod: this.contract.estimatedPeriod,
        earnings: this.getCalculatorEarnings,
      };

      try {
        const queryParams = preparePetsCalculationQueryParams(params);
        this.$router.push({ name: 'petsOffers', query: queryParams });
      } finally {
        this.offers.isLoading = false;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.insurance-calculator {
  &__container {
    display: flex;
    flex-direction: column;
  }

  &__controls-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  &__search-params {
    margin-bottom: 16px;
  }

  &__controls {
    display: flex;

    @media (max-width: 550px) {
      width: 100%;
    }
  }

  &__search {
    width: 400px;
    height: 50px;

    @media (max-width: 550px) {
      width: 100%;
    }

    ::v-deep &.button--disabled, ::v-deep &.button--loading {
      background-color: #F6F6F9 !important;
      color: #717680 !important;
    }
  }
}
</style>
